import React from 'react';
import { ToastOptions, toast } from 'react-toastify';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Typography from '@mui/material/Typography';
import theme from '@src/theme/theme';

import { dFlex } from '@assets/mixins';

import Link from '@components/common/Link';
import {
  boxStyles,
  boxWithHashLinkStyles,
} from '@components/common/Toast/styles';

import {
  AvailableChainIdType,
  TRX_LINK,
} from '@constants/common/chain.constants';
import {
  TOAST_DEFAULT_OPTIONS,
  ToastType,
} from '@constants/common/toast.constants';
import { Size } from '@constants/common/ui.constants';

type ToastContent = {
  title: string;
  description?: string;
  withLink?: {
    hash: string;
    chainId: AvailableChainIdType;
    title?: string;
  };
};

const COLOR_TYPE = {
  [ToastType.Success]: theme.palette.custom.accent.success,
  [ToastType.Error]: theme.palette.custom.accent.error,
  [ToastType.Info]: theme.palette.custom.accent.soft,
};

const showToast = (
  content: ToastContent,
  type: ToastType,
  toastOptions?: {
    hideIcon?: boolean;
    hideClose?: boolean;
    showProgressBar?: boolean;
  },
) => {
  const options: ToastOptions = {
    ...TOAST_DEFAULT_OPTIONS,
    type,
    className: `toast-container-${type}`,
    icon: !toastOptions?.hideIcon && (
      <InfoOutlinedIcon
        style={{ color: COLOR_TYPE[type] }}
        fontSize={Size.Small}
      />
    ),
    closeButton: !!toastOptions?.hideClose,
    hideProgressBar: toastOptions?.showProgressBar,
  };

  const renderBlock = () => (
    <>
      <div
        style={
          content?.withLink ? { ...boxWithHashLinkStyles } : { ...boxStyles }
        }
      >
        <div>
          <Typography variant="body1" color={theme.palette.custom.text.light}>
            {content.title}
          </Typography>
          {content?.description && (
            <Typography
              variant="body1"
              color={theme.palette.custom.text.light}
              style={{ marginTop: '4px', ...dFlex() }}
            >
              {content.description}
            </Typography>
          )}
        </div>
        {content?.withLink && (
          <Link
            pathname={`${TRX_LINK[content.withLink.chainId]}${content.withLink.hash}`}
            isNewTab
            variant="subtitle1"
            color={theme.palette.custom.text.light}
          >
            {content.withLink?.title || 'View'}
          </Link>
        )}
      </div>
    </>
  );

  toast(renderBlock(), options);
};

export default showToast;
